export const getChildrenAmount = (children) => (Array.isArray(children) ? children.length : Number(children) || 0);
